import auth0 from 'auth0-js';
import moment from 'moment';
import router from '../router';
import store, { registerAppToFCM } from '../store';

export function getToken() {
  return localStorage.getItem('access_token');
}
class AuthService {
  private authenticated = this.isAuthenticated();
  private auth0 = new auth0.WebAuth({
    domain: process.env.VUE_APP_AUTH0_DOMAIN,
    clientID: process.env.VUE_APP_AUTH0_CLIENTID,
    audience: process.env.VUE_APP_AUTH0_AUDIENCE,
    responseType: 'token',
    scope: 'profile email',
    redirectUri:
      `${location.protocol}//${location.hostname}:${location.port}/callback` || 'http://localhost:8080/callback',
  });

  constructor() {
    this.login = this.login.bind(this);
    this.setSession = this.setSession.bind(this);
    this.logout = this.logout.bind(this);
    this.isAuthenticated = this.isAuthenticated.bind(this);
  }

  public login(username, password) {
    return new Promise((res, rej) => {
      store.commit('SET_AUTHENTICATING', true);
      this.auth0.login(
        {
          email: username,
          password,
          realm: 'Username-Password-Authentication',
        },
        (err, data) => {
          if (!err) {
            return res(data);
          }
          store.dispatch('LOGIN_FAILED', err);
          store.commit('SET_AUTHENTICATING', false);
          return rej(err);
        },
      );
    });
  }

  public handleAuthentication() {
    this.auth0.parseHash(async (err, authResult) => {
      if (authResult && authResult.accessToken) {
        this.setSession(authResult);
        store.commit('SET_AUTHENTICATING', false);
        await registerAppToFCM(store);
        router.replace('/');
      } else if (err) {
        router.replace('/login');
        store.commit('SET_AUTHENTICATING', false);
      }
    });
  }

  public logout() {
    store.commit('SET_TOKEN', '');
    store.commit('SET_AUTH', false);
    localStorage.removeItem('expires_at');
    localStorage.removeItem('access_token');
    router.replace('/login');
  }

  public async isAuthenticated() {
    // Check whether the current time is past the
    // access token's expiry time

    const expiresAt = JSON.parse(localStorage.getItem('expires_at')!);

    const future = moment()
      .add(30, 'minute')
      .toDate()
      .getTime();
    if (future >= expiresAt) {
      return await this.refreshToken();
    }
    return new Date().getTime() < expiresAt;
  }
  public getToken() {
    return localStorage.getItem('access_token');
  }

  public refreshToken() {
    return new Promise(res => {
      store.commit('SET_AUTHENTICATING', true);
      if (this.auth0 && this.getToken() !== null) {
        this.auth0.checkSession({}, (err, authResult) => {
          if (err) {
            store.commit('SET_AUTHENTICATING', false);
            return res(false);
          }
          this.setSession(authResult);
          store.commit('SET_AUTHENTICATING', false);
          return res(true);
        });
      } else {
        store.commit('SET_AUTHENTICATING', false);
        return res(false);
      }
    });
  }
  private setSession(authResult) {
    // Set the time that the access token will expire at
    const expiresAt = JSON.stringify(authResult.expiresIn * 1000 + new Date().getTime());
    localStorage.setItem('access_token', authResult.accessToken);
    localStorage.setItem('expires_at', expiresAt);
    store.commit('SET_TOKEN', authResult.accessToken);
    store.commit('SET_AUTH', true);
  }
}

export default new AuthService();
